import React from 'react';

import classNames from 'classnames';
import AddToolboxIcon from 'icons/addtoolbox-xl.svg';
import NoResultsIcon from 'icons/noresults-xl.svg';
import PropTypes from 'prop-types';

import FilledButton from 'components/application/buttons/FilledButton';

export default function ResourceBlankNotice({
  addButtonText,
  icon,
  isAddable,
  noResourcesDescription,
  noResourcesDescriptionClasses,
  noResourcesFoundTitle,
  noResourcesTitle,
  noResourcesTitleAdditionalClasses,
  onAdd,
  totalCount,
}) {
  return totalCount > 0 ?
      <section className='section section--notice tw-rounded-t-none tw-border-grey-100 tw-bg-white'>
        <NoResultsIcon
          className='[&_path]:tw-fill-grey-300'
          height={64}
          width={64}
        />
        <h2 className='section__header tw-text-l tw-font-semibold tw-text-grey-900'>
          {noResourcesFoundTitle}
        </h2>
      </section>
    : <section className='section section--notice tw-border-grey-100 tw-bg-white'>
        {icon || (
          <AddToolboxIcon
            className='[&_path]:tw-fill-grey-500'
            height={64}
            width={64}
          />
        )}
        <h2
          className={classNames(
            'section__header tw-text-l tw-font-semibold tw-text-grey-900',
            noResourcesTitleAdditionalClasses,
          )}
        >
          {noResourcesTitle}
        </h2>
        <p
          className={
            noResourcesDescriptionClasses ||
            'section__content section__content--md'
          }
        >
          {noResourcesDescription}
        </p>
        {isAddable && addButtonText && onAdd && (
          <FilledButton color='mint' onClick={onAdd}>
            {addButtonText}
          </FilledButton>
        )}
      </section>;
}

ResourceBlankNotice.propTypes = {
  addButtonText: PropTypes.string,
  icon: PropTypes.element,
  isAddable: PropTypes.bool,
  noResourcesFoundTitle: PropTypes.string,
  noResourcesDescription: PropTypes.string,
  noResourcesDescriptionClasses: PropTypes.string,
  noResourcesTitle: PropTypes.string,
  noResourcesTitleAdditionalClasses: PropTypes.string,
  onAdd: PropTypes.func,
  totalCount: PropTypes.number.isRequired,
};
